import React from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import HolographicPlaceholder from "./HolographicPlaceholder";
import { useCart } from "../context/CartContext";
import { formatPrice } from "../lib/api";
import { toast } from "sonner";

export default function ProductCard({ product, index = 0 }) {
  const { add } = useCart();

  const onAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    add(product, 1);
    toast.success(`${product.name} added to cart`);
  };

  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="card-elev rounded-xl p-3 block group animate-fade-up opacity-0"
      style={{ animationDelay: `${Math.min(index * 60, 400)}ms` }}
    >
      <div className="relative">
        <HolographicPlaceholder
          label={product.name}
          subLabel={product.rarity || product.category}
          ratio="aspect-[3/4]"
          imageUrl={product.image_url}
        />
        {product.tag ? (
          <span className="absolute top-3 left-3 text-[10px] tracking-[0.22em] uppercase font-bold bg-[#B026FF]/20 text-[#E1B7FF] border border-[#B026FF]/40 backdrop-blur px-2 py-1 rounded">
            {product.tag}
          </span>
        ) : null}
      </div>

      <div className="px-1 pt-4 pb-1">
        <div className="text-[10px] tracking-[0.22em] uppercase text-[#B026FF]/80 font-bold">
          {(product.category || "").replace(/-/g, " ")}
        </div>
        <h3 className="mt-1 font-display font-medium text-white text-base leading-snug min-h-[3rem] line-clamp-2">
          {product.name}
        </h3>
        <div className="mt-3 flex items-end justify-between">
          <div>
            <div className="font-mono text-lg text-white">{formatPrice(product.price_cents)}</div>
            {product.old_price_cents ? (
              <div className="font-mono text-xs text-white/40 line-through">{formatPrice(product.old_price_cents)}</div>
            ) : null}
          </div>
          <button
            data-testid={`add-to-cart-${product.slug}`}
            onClick={onAdd}
            className="w-9 h-9 rounded-full btn-violet flex items-center justify-center group-hover:animate-glow-pulse"
            aria-label={`Add ${product.name} to cart`}
          >
            <Plus size={16} />
          </button>
        </div>
      </div>
    </Link>
  );
}
